import { css } from '@emotion/react';

const chartTableStyles = css`
    .sr-only {
        display: none;
    }

    .allocation-row {
        span {
            display: inline-block;
            margin-right: 5px;
            margin-bottom: 2px;
        }

        .color-swatch {
            height: 12px;
            width: 12px;
            vertical-align: middle;
        }
    }
`;

export const chartThemeTableStyles = css`
    color: var(--default-text-color);

    .sr-only {
        display: none;
    }

    .allocation-row {
        span {
            display: inline-block;
            margin-right: 5px;
            margin-bottom: 2px;
            font-family: var(--font-family-regular);
            color: var(--default-text-color);
            font-weight: var(--font-weight-regular);
            font-size: var(--font-size-regular);
        }

        .color-swatch {
            height: 12px;
            width: 12px;
            vertical-align: middle;
        }
    }

    table {
        width: var(--tableComponent-tableWidth);

        th {
            border-style: var(--tableComponent-thBorderStyle);
            border-color: var(--tableComponent-thBorderColor);
            border-width: var(--tableComponent-thBorderWidth);
            font-family: var(--tableComponent-thFontFamily);
            color: var(--tableComponent-thTextColor);
            font-weight: var(--tableComponent-thFontWeight);
            font-size: var(--tableComponent-thFontSize);
            line-height: var(--tableComponent-thLineHeight);
            padding: var(--tableComponent-thPadding);
        }

        td {
            border-style: var(--tableComponent-tdBorderStyle);
            border-color: var(--tableComponent-tdBorderColor);
            border-width: var(--tableComponent-tdBorderWidth);
            font-family: var(--tableComponent-tdFontFamily);
            color: var(--tableComponent-tdTextColor);
            font-weight: var(--tableComponent-tdFontWeight);
            font-size: var(--tableComponent-tdFontSize);
            line-height: var(--tableComponent-tdLineHeight);
            padding: var(--tableComponent-tdPadding);
        }

        tbody {
            tr:nth-child(odd) {
                background-color: var(--tableComponent-alternatedRowsBGColor);
            }
        }

        tr:last-child {
            td {
                border: none;
            }
        }
    }
`;

export default chartTableStyles;
